const APP_OVERVIEW_FORECAST_PUBLISH_BY_APP = 'app_overview_forecast_publish_by_app';
const COMPANY_MPI_WIDGET_SEEN = 'company_mpi_widget_seen';
const TRACKING_SITE_NAVIGATION = 'tracking_site_navigation';

export {
  APP_OVERVIEW_FORECAST_PUBLISH_BY_APP,
  COMPANY_MPI_WIDGET_SEEN,
  TRACKING_SITE_NAVIGATION,
};
